import React from 'react'
import s from './Casino.module.scss'

export const Casino = () => {
    return <div className={s.component}>
    </div>
}

